export const getBuildNumber = (versionString: string | null): number => {
  if (!versionString) return 0;
  const match = versionString.match(/\((\d+)\)/);
  return match ? parseInt(match[1], 10) : 0;
};
